module.exports = __webpack_public_path__ + "static/img/flow.b304670.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flow.png
// module id = kb+R
// module chunks = 10